export const PTInputTextArea = {
  root: {
    className: 'ax-input ax-textarea',
  },
};
